import { LogLevel } from "@azure/msal-browser";
import * as msal from "@azure/msal-browser";

/**
 * The configuration for the Microsoft Authentication Library
 * @type {msal.Configuration}
 */
export const msalConfig = {
  auth: {
    clientId: "b0b8b355-d8bc-4bae-b4df-752853cc55fa",
    authority:
      "https://login.microsoftonline.com/f6befb9e-9049-47c5-bce2-9c405eaeb937",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Calls the Microsoft Graph API
 * @param {string} endpoint - The endpoint to call
 * @param {string} token - The token to use for the request
 * @returns {Promise<Object>} - The response from the API
 */
export async function callMsGraph(endpoint, token) {
  const response = await fetch(`https://graph.microsoft.com/v1.0${endpoint}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.json();
}

/**
 * The login request for the Microsoft Graph API
 * @type {msal.SilentFlowRequest}
 */
export const loginRequest = {
  scopes: ["api://87a288bd-081d-4ebe-95fb-853e7ec9235f/access_as_user"],
};

/**
 * The Microsoft Authentication Library instance
 * @type {msal.PublicClientApplication}
 */
export const msalInstance = new msal.PublicClientApplication(msalConfig);
